import { useContext, useEffect, useState } from "react";

import OnboardingBoilerplate from "./OnboardingBoilerplate";
import styled from "styled-components";
import { serverLine } from "../../../../controllers/network/serverLine";
import Context from "../../../../Context";
import { useTranslation } from "react-i18next";
import ngoTypes from "../../../../data/ngoTypes";
import NgoTypeCard from "../../../applicationUI/ngo/NgoTypeCard";

const UploadSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
`;

const Text = styled.div`
  font-size: 15px;
  opacity: 0.7;
`;

const InfoSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0 0;
  margin-top: 0;

  gap: 10px;
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

const categories = ngoTypes;

const Icon = styled.div``;

export default function AskNgoType({ asEditPage }) {
  const { loggedInUser, setLoggedInUser } = useContext(Context);
  const [value, setValue] = useState(null);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (loggedInUser) {
      if (loggedInUser.ngoType) setValue(loggedInUser.ngoType);
    }
  }, []);

  function selectType(newType) {
    return () => {
      setValue(newType);
    };
  }

  return (
    <OnboardingBoilerplate
      asEditPage={asEditPage}
      editPageTitle="Ngo Type"
      title={"Select NGO type"}
      desc={"Select the category that best represents your NGO"}
      onSubmit={onSubmit}
      loading={loading}
    >
      <InfoSection>
        {categories.map((item) => {
          return (
            <NgoTypeCard value={value} item={item} onChange={selectType} />
          );
        })}
      </InfoSection>
    </OnboardingBoilerplate>
  );

  async function onSubmit() {
    if (!value) return window.popupAlert("Please! select a ngo type");

    setLoading(true);

    try {
      await serverLine.patch("/me", { changes: { ngoType: value } });
      setLoading(false);

      let newLoggedInUser = { ...loggedInUser, ngoType: value };
      setLoggedInUser(newLoggedInUser);

      window.popupAlert(t("saved"));
    } catch (e) {
      window.popupAlert(e.message);
      setLoading(false);
    }
  }
}
